export const ALERT_TYPE = 'alert';
export const REDIRECT_TYPE = 'redirect';

const SYSTEM_FEATURE = 'System';

export class BaseError extends Error {
  // name of the feature
  public feature: string;
  // error type => expected action
  public errorType: string;
  constructor(message: string) {
    super(message);
    this.constructor = BaseError;
    Object.setPrototypeOf(this, BaseError.prototype);
    this.name = this.constructor.name;
    this.feature = SYSTEM_FEATURE;
    this.errorType = ALERT_TYPE;
  }
}

export function isBaseError(error: any): error is BaseError {
  return error instanceof BaseError;
}
